export const convertToBase64 = (file: any) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const getHeaders = () => {
  const userDetails: any = localStorage.getItem('c360labs/user-details');
  const token = JSON.parse(userDetails).access_token;

  return {
    Authorization: `Bearer ${token}`,
  };
};

export const getBase64File = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
